/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: constants.ts (Ring Groups Constants)
 🗓️ Created: 2025-01-05
 🧩 Description:
    Constants and default values for Ring Groups module.

 🔧 Notes:
    - Centralized constants for better maintainability
    - Default form state values
    - Strategy options and known settings keys

 🔁 Last Updated: 2025-01-05 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import { FormState, Strategy } from './types/ringGroups.types';

export const STRATEGY_OPTIONS: Strategy[] = [
  'simultaneous',
  'sequence',
  'enterprise',
  'random',
  'rollover'
];

export const KNOWN_SETTINGS_KEYS = new Set([
  'extension',
  'greeting',
  'cid_name_prefix',
  'cid_number_prefix',
  'distinctive_ring',
  'ringback',
  'call_screen',
  'call_forward',
  'follow_me',
  'missed_call_action',
  'forward_enabled',
  'forward_number',
  'forward_toll_allow',
  'confirm_key',
  'confirm_file',
  'presence_id',
  'record',
  'call_timeout_override'
]);

export const DEFAULT_FORM_STATE: FormState = {
  name: '',
  extension: '',
  context: 'default',
  strategy: 'simultaneous',
  ringTimeout: '30',
  fallbackModule: 'none',
  fallbackValue: '',
  callerIdName: '',
  callerIdNumber: '',
  distinctiveRing: '',
  ringback: '${us-ring}',
  greeting: '',
  callScreen: 'disabled',
  callForward: 'disabled',
  followMe: 'disabled',
  missedCallAction: 'none',
  forwardEnabled: 'disabled',
  forwardNumber: '',
  forwardTollAllow: '',
  confirmKey: '1',
  confirmFile: 'ivr/press_1_to_accept.wav',
  presenceId: '',
  record: false,
  callTimeoutOverride: '',
  skipBusy: false,
  enabled: true,
  description: '',
  createdAt: null,
  updatedAt: null
};

